import React from "react";
import { Route } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout.js";
import PropTypes from 'prop-types';
import "../App.css?v=2"

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    <PublicLayout>
      <Component {...props} />
    </PublicLayout>
  )} />
)

PublicRoute.propTypes = {
  component:PropTypes.node
};

export default PublicRoute